import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";

declare var ko: any;

export class config_marketplace_orphans_template extends vnTemplate {

    protected getMainElementType(): string {
        return "div";
    }

    protected getTemplateName(): string {
        return "config_marketplace_orphans_template";
    }

    protected getTemplateHtml(): string {
        return /*html*/`
            <div class="w-form marketplace-config orphans-config">
               <div class="form-header">
                  <input type="hidden">
                  <h3 class="form-title">Marketplace Orphans Settings</h3>
               </div>

               <div class="form-body">

                   <!-- Tabs strip -->
                   <div class="orphan-tabs">
                       <ul class="orphan-tab-headers" data-bind="foreach: configs">
                           <li class="orphan-tab-header" data-bind="css: { active: $data === $parent.activeConfig() }, event: { click: function(){ $parent.activeConfig($data); } }">
                               <span data-bind="text: label"></span>
                               <button class="orphan-tab-close icon i-delete"
                                       type="button"
                                       title="Delete this tab"
                                       data-bind="visible: $parent.configs().length > 1,
                                                  event: { click: function(){ $parent.onDeleteTab($data); }, clickBubble: false }">
                                   <span class="hidden-text">Delete</span>
                               </button>
                           </li>
                       </ul>
                       <button class="btn border icon i-plus orphan-tab-add" type="button" data-bind="event: { click: onAddTab }">
                           <span>Add Tab</span>
                       </button>
                   </div>

                   <!-- Active tab body -->
                   <!-- ko with: activeConfig -->
                       <h3 class="form-sub-title icon i-listing-2-preview">Provider Sponsor (Waterfall Order)</h3>
                       <div class="form-group">
                           <label class="form-label">Configure the provider waterfall for orphans. Drag to reorder. Each provider can appear only once.</label>
                       </div>
                       <div class="mp-warning">
                           This order controls which provider's listings are shown first in orphan sponsored placements. Available providers are inherited from the main Marketplace configuration.
                       </div>
                       <div class="form-group" data-bind="foreach: provider_sponsor, dragAndDrop: { observableArray: provider_sponsor, childrenSelector: '.mp-entry', dragHandleSelector: '.mp-drag' }">
                           <div class="mp-entry">
                               <div class="mp-drag icon i-drag">
                                   <span class="mp-position" data-bind="text: ($index() + 1)"></span>
                               </div>
                               <div class="mp-provider" data-bind="text: provider"></div>
                               <div class="mp-field">
                                   <label>Places</label>
                                   <input type="number" min="1" data-bind="value: places">
                               </div>
                               <button class="btn border only-icon icon border i-delete" type="button" data-bind="event: { click: $parent.onRemoveFromSponsor }"><span class="hidden-text">Remove</span></button>
                           </div>
                       </div>
                       <div class="form-group" data-bind="visible: provider_sponsor().length === 0">
                           <label class="form-label" style="text-align: center; font-style: italic;">No entries in the sponsor list.</label>
                       </div>
                       <div class="mp-error" data-bind="visible: totalPlacesExceeded">
                           Total sponsor places cannot exceed 10 (current: <span data-bind="text: totalPlaces"></span>).
                       </div>

                       <div class="form-group" data-bind="visible: addable_providers().length > 0">
                           <div class="mp-entry mp-add-form">
                               <div class="mp-field">
                                   <label>Provider</label>
                                   <select data-bind="options: addable_providers, value: newEntryProvider, optionsCaption: '-- Select --'"></select>
                               </div>
                               <div class="mp-field">
                                   <label>Places</label>
                                   <input type="number" min="1" data-bind="value: newEntryPlaces">
                               </div>
                               <button class="btn border icon i-plus" type="button" data-bind="event: { click: onAddToSponsor }, enable: newEntryProvider()"><span>Add</span></button>
                           </div>
                       </div>

                       <div data-bind="visible: available_providers().length > 0">
                           <h3 class="form-sub-title icon i-listing-2-preview">Available Providers</h3>
                           <div class="form-group">
                               <label class="form-label">These providers are not blocked and can be added to the sponsor list or blocked.</label>
                           </div>
                           <div class="form-group" data-bind="foreach: available_providers">
                               <div class="form-body w-pinned">
                                   <div class="pinned-form entry">
                                       <div class="w-title">
                                           <span class="pinned-title" data-bind="text: $data"></span>
                                       </div>
                                       <div class="w-btn">
                                           <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onBlockProvider }"><span class="hidden-text">Block</span></button>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>

                       <div data-bind="visible: blocked_providers().length > 0">
                           <h3 class="form-sub-title icon i-listing-2-preview">Blocked Providers</h3>
                           <div class="form-group">
                               <label class="form-label">These providers are blocked and will not be used for orphans.</label>
                           </div>
                           <div class="form-group" data-bind="foreach: blocked_providers">
                               <div class="form-body w-pinned">
                                   <div class="pinned-form entry">
                                       <div class="w-title">
                                           <span class="pinned-title" data-bind="text: $data"></span>
                                       </div>
                                       <div class="w-btn">
                                           <button class="btn border icon i-plus" type="button" data-bind="event: { click: $parent.onUnblockProvider }"><span class="hidden-text">Unblock</span></button>
                                       </div>
                                   </div>
                               </div>
                           </div>
                       </div>
                   <!-- /ko -->

               </div>

               <div class="form-footer">
                  <button data-bind="event: { click: onClickCancelOrphansSettings }" title="There will be no changes made" class="btn" type="button">Cancel</button>
                  <button data-bind="event: { click: onClickSaveOrphansSettings }, disable: anyPlacesExceeded" class="btn highlight" type="button">Save</button>
               </div>
            </div>

            <style>
                .orphans-config .orphan-tabs {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 0.5rem;
                    border-bottom: 2px solid #eee;
                    margin-bottom: 1rem;
                    padding-bottom: 0.25rem;
                }
                .orphans-config .orphan-tab-headers {
                    list-style: none;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    flex-direction: row;
                    gap: 0.25rem;
                    flex-wrap: wrap;
                    flex: 1 1 auto;
                }
                .orphans-config .orphan-tab-header {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    padding: 0.4rem 0.9rem;
                    border: 1px solid #ddd;
                    border-bottom: none;
                    border-radius: 4px 4px 0 0;
                    background-color: #f5f5f5;
                    cursor: pointer;
                    user-select: none;
                }
                .orphans-config .orphan-tab-header.active {
                    background-color: #fff;
                    font-weight: 700;
                    border-color: #bbb;
                    position: relative;
                    top: 2px;
                }
                .orphans-config .orphan-tab-close {
                    border: none;
                    background: transparent;
                    cursor: pointer;
                    padding: 0;
                    line-height: 1;
                    opacity: 0.5;
                }
                .orphans-config .orphan-tab-close:hover {
                    opacity: 1;
                    color: #c0392b;
                }
                .orphans-config .orphan-tab-add {
                    flex-shrink: 0;
                }
                .marketplace-config .mp-entry {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 1.5rem;
                    padding: 0.4rem 0.6rem;
                    margin-bottom: 2px;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    background-color: #f9f9f9;
                }
                .marketplace-config .mp-drag {
                    display: flex;
                    align-items: center;
                    gap: 0.2rem;
                    cursor: grab;
                    flex-shrink: 0;
                }
                .marketplace-config .mp-drag::before {
                    font-size: 1.2rem;
                    width: auto;
                }
                .marketplace-config .mp-position {
                    font-weight: 700;
                    font-size: 1.1rem;
                    min-width: 1.2rem;
                    text-align: center;
                }
                .marketplace-config .mp-provider {
                    font-weight: 700;
                    font-size: 1.2rem;
                    min-width: 6rem;
                }
                .marketplace-config .mp-field {
                    display: flex;
                    align-items: center;
                    gap: 0.3rem;
                    flex-shrink: 0;
                }
                .marketplace-config .mp-field label {
                    font-size: 0.85em;
                    opacity: 0.7;
                    margin: 0;
                    white-space: nowrap;
                }
                .marketplace-config .mp-field input[type="number"] {
                    width: 65px;
                    padding: 0.25rem 0.4rem;
                    text-align: center;
                    border: 1px solid #ccc;
                    border-radius: 3px;
                }
                .marketplace-config .mp-field select {
                    min-width: 120px;
                    padding: 0.25rem 0.4rem;
                    border: 1px solid #ccc;
                    border-radius: 3px;
                }
                .marketplace-config .mp-entry > .btn {
                    margin-left: auto;
                    flex-shrink: 0;
                }
                .marketplace-config .mp-add-form {
                    border-style: dashed;
                    background-color: transparent;
                }
                .marketplace-config .mp-error {
                    color: #c0392b;
                    font-size: 0.9em;
                    padding: 0.3rem 0;
                }
                .marketplace-config .mp-warning {
                    background-color: #fffbe6;
                    border: 1px solid #ffe58f;
                    border-radius: 4px;
                    color: #7d5a00;
                    font-size: 0.95em;
                    padding: 0.5rem 1.25rem;
                    margin: 1rem 0;
                    font-size: 11px;
                }
            </style>
        `;
    }

    private buildColumnViewModel(configKey: string, providersObs: any): any {
        const col: any = {
            key: configKey,                                   // e.g. "orphanConfig1"
            label: ko.observable(this.labelFromKey(configKey)),
            providers: providersObs,                          // shared reference to root master list (read-only here)
            provider_sponsor: ko.observableArray([]),
            blocked_providers: ko.observableArray([]),
            newEntryProvider: ko.observable(null),
            newEntryPlaces: ko.observable(''),

            onRemoveFromSponsor: (entry) => {
                col.provider_sponsor.remove(entry);
            },

            onAddToSponsor: () => {
                const provider = col.newEntryProvider();
                if (!provider) return;

                const rawPlaces = col.newEntryPlaces();
                const parsedPlaces = parseInt(rawPlaces, 10);
                const places = isNaN(parsedPlaces) ? null : parsedPlaces;

                col.provider_sponsor.push({
                    provider: provider,
                    places: ko.observable(places)
                });

                col.newEntryProvider(null);
                col.newEntryPlaces('');
            },

            onBlockProvider: (provider) => {
                alert("Your changes will apply to " + col.label() + " only. Other orphan pages and /marketplace/ will not be affected.");

                const toRemove = col.provider_sponsor().filter(e => e.provider === provider);
                toRemove.forEach(e => col.provider_sponsor.remove(e));
                col.blocked_providers.push(provider);
            },

            onUnblockProvider: (provider) => {
                col.blocked_providers.remove(provider);
            }
        };

        col.available_providers = ko.computed(() => {
            const all = col.providers();
            const blocked = col.blocked_providers();
            return all.filter(p => blocked.indexOf(p) === -1);
        });

        col.addable_providers = ko.computed(() => {
            const available = col.available_providers();
            const sponsorNames = col.provider_sponsor().map(e => e.provider);
            return available.filter(p => sponsorNames.indexOf(p) === -1);
        });

        col.totalPlaces = ko.computed(() => {
            return col.provider_sponsor().reduce((sum, entry) => {
                const val = parseInt(ko.unwrap(entry.places), 10);
                return sum + (isNaN(val) ? 0 : val);
            }, 0);
        });

        col.totalPlacesExceeded = ko.computed(() => {
            return col.totalPlaces() > 10;
        });

        return col;
    }

    private labelFromKey(key: string): string {
        const match = /^orphanConfig(\d+)$/.exec(key);
        return match ? ("Orphan Config " + match[1]) : key;
    }

    private numberFromKey(key: string): number {
        const match = /^orphanConfig(\d+)$/.exec(key);
        return match ? parseInt(match[1], 10) : 0;
    }

    protected buildViewModel(): any {
        const vm: any = {
            providers: ko.observableArray([]),
            configs: ko.observableArray([]),
            activeConfig: ko.observable(null),

            onAddTab: () => {
                const existing = vm.configs();
                const maxN = existing.reduce((m, c) => Math.max(m, this.numberFromKey(c.key)), 0);
                const newKey = "orphanConfig" + (maxN + 1);
                const newCol = this.buildColumnViewModel(newKey, vm.providers);
                vm.configs.push(newCol);
                vm.activeConfig(newCol);
            },

            onDeleteTab: (col) => {
                const list = vm.configs();
                if (list.length <= 1) return;

                const label = ko.unwrap(col.label) || col.key;
                const typed = window.prompt(
                    'Deleting "' + label + '" will remove its configuration on Save.\n\nType DELETE (in capitals) to confirm.'
                );
                if (typed !== 'DELETE') {
                    return;
                }

                const idx = list.indexOf(col);
                vm.configs.remove(col);
                if (vm.activeConfig() === col) {
                    const remaining = vm.configs();
                    const nextIdx = Math.max(0, Math.min(idx, remaining.length - 1));
                    vm.activeConfig(remaining[nextIdx] || null);
                }
            },

            onClickCancelOrphansSettings: () => {
                this.caller.cancelOrphansSettings();
            },

            onClickSaveOrphansSettings: () => {
                this.caller.saveOrphansSettings();
            }
        };

        vm.anyPlacesExceeded = ko.computed(() => {
            return vm.configs().some(c => c.totalPlacesExceeded());
        });

        return vm;
    }

    private applyColumnSettings(col: any, orphanConfig: any) {
        const blocked = (orphanConfig && Array.isArray(orphanConfig.blocked_providers))
            ? orphanConfig.blocked_providers
            : [];
        col.blocked_providers(blocked);

        let sponsor = [];
        if (orphanConfig && Array.isArray(orphanConfig.provider_sponsor)) {
            sponsor = orphanConfig.provider_sponsor.map(entry => {
                if (typeof entry === 'string') {
                    return { provider: entry, places: ko.observable(null) };
                }
                return {
                    provider: entry.provider,
                    places: ko.observable(entry.places != null ? entry.places : null)
                };
            });
        }
        col.provider_sponsor(sponsor);
    }

    public setOrphansSettings(providers: string[], orphanConfigs: any) {
        const vm = this.getTemplateViewModel();
        const defaultProviders = ['lotlinx', 'carzing', 'carsAndBids'];
        const list = (Array.isArray(providers) && providers.length > 0) ? providers : defaultProviders;
        vm.providers(list);

        const keys = (orphanConfigs && typeof orphanConfigs === 'object')
            ? Object.keys(orphanConfigs).filter(k => /^orphanConfig\d+$/.test(k))
            : [];

        keys.sort((a, b) => this.numberFromKey(a) - this.numberFromKey(b));

        if (keys.length === 0) {
            keys.push('orphanConfig1');
        }

        const cols = keys.map(k => {
            const col = this.buildColumnViewModel(k, vm.providers);
            this.applyColumnSettings(col, orphanConfigs ? orphanConfigs[k] : null);
            return col;
        });

        vm.configs(cols);
        vm.activeConfig(cols[0] || null);
    }

    private serializeColumn(col: any): any {
        const sponsor = col.provider_sponsor().map(entry => {
            const placesVal = parseInt(ko.unwrap(entry.places), 10);
            const places = isNaN(placesVal) ? null : placesVal;
            return { provider: entry.provider, places: places };
        });

        return {
            provider_sponsor: sponsor,
            blocked_providers: col.blocked_providers()
        };
    }

    public getOrphansSettings() {
        const vm = this.getTemplateViewModel();
        const out: any = {};
        vm.configs().forEach((col) => {
            out[col.key] = this.serializeColumn(col);
        });
        return { orphanConfigs: out };
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/config_marketplace_orphans_template.ts